import Header from './header';
import States from '../../helpers/states'

export default class HeaderDesktop extends Header {
    constructor(...args) {
        super(...args);

        this._isEdge = ( ENV.browser == 'edge' );
        this._isHome = this.dom.component.classList.contains('is-home');
        let noLoopVideoContainers = this.dom.component.querySelectorAll('.js-noLoopVideo-container')
        let START_ANIMATION_AT = .95
        let hideAtBeginning = this.dom.component.classList.contains('hideAtBeginning')
        let self = this

        this.dom.noLoopComponents = []
        this.dom.contentsToAnim = this.dom.jsTextualContent.querySelectorAll('.js-animate')

        for(let i = 0; i < noLoopVideoContainers.length; i++){

            let noLoopVideoContainer = noLoopVideoContainers[i]
            let noLoopVideoPoster = noLoopVideoContainer.querySelector('.js-noLoopVideo-poster')
            let noLoopVideo = noLoopVideoContainer.querySelector('.js-noLoopVideo')
            let isAnimatedAttribute = noLoopVideoContainer.getAttribute('data-animated')
            let isAnimated = isAnimatedAttribute && isAnimatedAttribute == 'true' ? true : false
 
            this.dom.noLoopComponents.push({
                container: noLoopVideoContainer,
                poster: noLoopVideoPoster,
                video: noLoopVideo,
                isAnimated,
                animationTriggered: false
            })

            if(noLoopVideo){
                if(isAnimated == true){
                    noLoopVideo.addEventListener('timeupdate', function(e){
                        let limit = this.duration * START_ANIMATION_AT
                        if(self.dom.noLoopComponents[i].animationTriggered == false && this.currentTime > limit){
                            self.dom.noLoopComponents[i].animationTriggered = true
                            self._animateNoLoopVideoPoster(self.dom.noLoopComponents[i])
                            if(hideAtBeginning){
                                self._showFirstTime()
                            }
                        }
                    })
                } else {
                    noLoopVideo.addEventListener('ended', () => {
                        if(noLoopVideoPoster){
                            noLoopVideoPoster.style.opacity = '1'
                            noLoopVideo.style.opacity = '0'
                            if(hideAtBeginning){
                                self._showFirstTime()
                            }
                        }
                    })
                }
            }
        }
    }

    _animateNoLoopVideoPoster(noLoopVideoComponent) {
        super._animateNoLoopVideoPoster(noLoopVideoComponent);
        TweenLite.to(noLoopVideoComponent.video, .3, {
            opacity: 0
        })
    }

    _showFirstTime(){

        let operator = -1

         let tl_showNewScreen = new TimelineMax({
             onComplete: () => {
                //  this._checkAllAnimEnd = setInterval( this._animEnd.bind(this) , 200 );
             }
         });
 
         /** Animation of the text **/
         tl_showNewScreen
             .staggerFromTo(
                 this.dom.contentsToAnim, 0.9,
                 { y: (States.height / 2) * -operator },
                 { y: 0, ease: Power4.easeOut, delay: 0.2, onStart: () => {
                    this.dom.jsTextualContent.style.display = 'block'
                 }},
                 0.08 * (-operator),
                 "start"
             )
             .staggerFromTo(
                 this.dom.contentsToAnim, 0.6,
                 { autoAlpha: 0 },
                 { autoAlpha: 1, ease: Power4.easeOut, delay: 0.2 },
                 0.08 * (-operator),
                 "start+=0.1"
             );
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/header/header.desktop.js